import { pxToRem } from "$global-providers/mui-provider/pixel-rem-calculators";
import type { Theme } from "@material-ui/core";
import type { StyleRulesCallback } from "@material-ui/core/styles/withStyles";

const styles: StyleRulesCallback<Theme, Record<string, unknown>, string> = (
  theme,
) => ({
  error: {
    transition: "bottom 0.2s ease-out, opacity 0.2s ease-out",
    fontFamily: [
      theme.typography.fontRegular,
      "Helvetica",
      "Arial",
      "sans-serif",
    ].join(","),
    color: theme.palette.error.main,
    width: "100%",
    position: "absolute",
    left: 0,
    right: 0,
    bottom: "25px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    zIndex: -1,
    fontSize: pxToRem(12),
    lineHeight: pxToRem(14),
    letterSpacing: "-0.01rem",
    opacity: 0,
  },
  visited: {
    bottom: "5px",
    zIndex: 1,
    opacity: 1,
  },
});

export default styles;
